import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Button from '@components/ui/Button'
import { Props } from '@components/ui/Button/Button'
import { useExportFile } from '@lib/file'

interface IExportButtonProps extends Props {
  query?: Record<string, any>
  apiUrl?: string
  fileName?: string
  isNotSupportAdmin?: boolean
  extension?: string
  icon?: React.ReactNode
}
//新增extension
const Export = React.memo<IExportButtonProps>(props => {
  const { t } = useTranslation()
  const {
    query,
    fileName,
    apiUrl,
    extension,
    isNotSupportAdmin = false,
    icon,
    loading,
    onClick,
    ...others
  } = props

  const exportFileHook = useExportFile({
    filename: fileName || '',
    apiUrl: apiUrl || '',
    isNotSupportAdmin,
    extension,
  })

  // 如果有 onClick，使用傳入的 loading；否則使用 useExportFile 的 isExporting
  const isLoading = onClick ? loading : exportFileHook.isExporting

  return (
    <Button
      color="ghost"
      onClick={onClick || (() => exportFileHook.exportFile(query))}
      className="ml-16"
      loading={isLoading}
      {...others}>
      <IconWrapper>
        {icon || ''}
        {t('common:exportCurrentFile')}
      </IconWrapper>
    </Button>
  )
})

export default React.memo<Partial<IExportButtonProps>>(props => {
  if (props.fileName) {
    return <Export {...(props as any)} />
  } else {
    return null
  }
})

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .anticon[style*='fontSize'] svg,
  .anticon[style*='font-size'] svg {
    width: auto !important;
    height: auto !important;
  }
`
